module.exports = __webpack_public_path__ + "img/logo-sm.86d79997.png";